<template>
    <div class="background">
        <div class="inputForm">
            <van-field v-model="phone" type="number" size="large" placeholder="请输入手机号码" clearable></van-field>
            <div style="margin: 1rem 1rem; text-align: left;">
                选择充值金额
            </div>
            <van-row style="margin-left: 1rem;">
                <van-col span="8">
                    <van-button plain hairline type="danger" class="priceButton"
                                @click="showConfirm(30, '30元话费')">
                        <div style="margin: -1rem; line-height: 2rem; padding-top: 0.8rem;">
                            <div style="font-size: 1.5rem; font-weight: bold;">30元</div>
                            <div style="font-size: 0.9rem;">白条支付价 20元</div>
                        </div>
                    </van-button>
                </van-col>
                <van-col span="8">
                    <van-button plain hairline type="danger" class="priceButton"
                                @click="showConfirm(50, '50元话费')">
                        <div style="margin: -1rem; line-height: 2rem; padding-top: 0.8rem;">
                            <div style="font-size: 1.5rem; font-weight: bold;">50元</div>
                            <div style="font-size: 0.9rem;">白条支付价 40元</div>
                        </div>
                    </van-button>
                </van-col>
                <van-col span="8">
                    <van-button plain hairline type="danger" class="priceButton"
                                @click="showConfirm(1000, '1000元话费')">
                        <div style="margin: -1rem; line-height: 2rem; padding-top: 0.8rem;">
                            <div style="font-size: 1.5rem; font-weight: bold;">1000元</div>
                            <div style="font-size: 0.9rem;">白条支付价 1000元</div>
                        </div>
                    </van-button>
                </van-col>
            </van-row>

            <van-row style="margin: 2rem 1rem;">
                <van-button type="danger" size="large" :url="jobInfo.jobLink">点击开通白条</van-button>
            </van-row>

            <div style="text-align: center; font-size: 1rem; margin-top: 2rem;">
                温馨提示<br/>
                白条新用户享受特价充值<br/>
                非白条新用户无法享受此优惠
            </div>

            <div style="height: 3rem; margin-top: 1rem; text-align:center;">
                <van-row>
                    <van-col span="6">
                        <van-button plain hairline type="danger" size="small" @click="recordDialog=true">
                            支付记录
                        </van-button>
                    </van-col>
                    <van-col span="6">
                        <van-button plain hairline type="danger" size="small" @click="ruleDialog=true">
                            活动规则
                        </van-button>
                    </van-col>
                    <van-col span="6">
                        <van-button plain hairline type="danger" size="small"
                                    url="https://www9.53kf.com/m.php?kf_sign=jk4NjMTU5MU0MzExNzc5NTk0NDkxMDEyNzIyMjQyODA%253D&arg=10224280&style=1&cid=72224280">
                            联系客服
                        </van-button>
                    </van-col>
                    <van-col span="6">
                        <van-button plain hairline type="danger" size="small" @click="shareDialogVisible=true">
                            分享海报
                        </van-button>
                    </van-col>
                </van-row>
            </div>
        </div>

        <van-dialog v-model="confirmDialog" confirm-button-text="去充值" show-cancel-button @confirm="confirmRecharge">
            <div style="line-height: 2rem; padding: 1rem 0;">
                确定要为{{phone}}充值{{sum}}元吗?<br/>
                一旦确认充值，充值号码无法变更!<br/>
                超值优惠仅限白条新用户享受<br/>
                <van-button plain hairline type="danger" :url="jobInfo.jobLink">点击开通白条</van-button>
            </div>
        </van-dialog>

        <van-dialog v-model="recordDialog" confirm-button-text="去下载" show-cancel-button @confirm="confirmRecord">
            <div style="line-height: 2rem; padding: 1rem;">
                支付记录请在【京东金融】App中查看<br/>
                京东金融新用户还可在App内领取6元金贴
            </div>
        </van-dialog>

        <van-dialog v-model="ruleDialog" confirm-button-text="我知道了">
            <div style="padding: 1rem; height: 35rem; overflow-y: scroll; text-align: left; font-size: 1rem;">
                什么是京东白条？<br/>
                白条是京东推出的【先消费，后付款】的全新支付方式。在京东网站使用白条进行付款，可以享受账期内延后付款或者最长24期的分期付款方式。白条不支持转账功能，部分用户支持白条取现服务。<br/>
                <br/>
                怎么还白条？<br/>
                下载京东金融App-登录-首页左上角“我的待还”-提前还款<br/>
                <br/>
                活动规则<br/>
                1.本活动仅针对未激活白条用户，重开户用户（注销白条后重新激活）不享受此福利。<br/>
                2.用户通过本页面成功激活白条后可获得满30元减10元话费券，可用于在本页面充值话费。<br/>
                3.通过其他途径开通白条的用户不享受话费券优惠。<br/>
                4.优惠券可在京东金融App-头像-我的卡券或京东App-我的钱包-优惠券中查看，具体获得的优惠券以实际到账为准，优惠券使用有效期以券面展示为准；请在规定期限内使用，过期将自动作废。<br/>
                5.白条开通成功后，将推荐作为您在京东支付线上收银台的优先支付方式，在京东App、京东到家、7FRESH七鲜、一号店等场景消费时，将优先使用白条进行付款。您可通过以下路径修改默认支付方式：【京东金融APP-左上角“我的”-右上角“设置”-支付设置-默认支付工具设置】。白条优先支付仅限于支持白条的场景。<br/>
                <br/>
                营销细则<br/>
                1.如用户以参与营销活动或使用营销工具所获得的优惠权益进行盈利或非法获利，或者京东金融有合理理由怀疑用户存在不当使用优惠工具或优惠权益的，京东金融将取消用户的参与资格，并有权撤销相关违规交易、收回优惠权益(含已使用及未使用的)，必要时将追究用户的法律责任。<br/>
                <br/>
                2.如用户曾经存在、出现或经京东金融合理怀疑存在违背诚实信用原则的行为，用户将可能面临无法获取/使用优惠权益、仅可获取/使用部分优惠权益的情况，必要时将追究用户的法律责任，具体如下:<br/>
                （1）通过任何不正当手段或以违反诚实信用原则的方式参与活动的，如通过与其他用户、商家串通或利用机器等方式进行作弊、刷取活动道具或积分等扰乱活动秩序的行为；<br/>
                （2）通过任何不正当手段或以违反诚实信用原则的方式达成交易的，如利用秒杀器等工具下单、套取优惠利差、虚假下单交易、提供虚假交易信息等扰乱活动秩序、违反交易规则的行为；<br/>
                （3）用户欠缺交易意愿，如利用退款流程的便利性以实现获取优惠权益目的，交易后出现大量退款的；<br/>
                （4）其他违反诚实信用原则的行为。<br/>
                <br/>
                3.同一手机号、身份证号、京东账户、银行卡号、终端设备等与用户身份相关的信息，其中任意一项或者多项存在相同、相似或非真实有效等情况的，均可能被认定为同一用户，按照营销活动规则中的同一用户处理。<br/>
                <br/>
                4.如出现不可抗力或情势变更的情况（包括但不限于重大灾害时间、活动受政府机关指令需要停止举办或调整的、活动遭受严重网络攻击或因系统故障需要暂停举办的），京东金融有权暂停或取消本次活动，并可依相关法律法规的规定主张免责。<br/>
            </div>
        </van-dialog>

        <van-dialog v-model="shareDialogVisible" confirm-button-text="长按图片保存至本地">
            <img :src="shareImgSrc" width="100%"/>
            <vue-canvas-poster :widthPixels="640" :painting="painting" @success="success" @fail="fail">
            </vue-canvas-poster>
        </van-dialog>
    </div>
</template>

<script>
    import jdPayAPI from '@/api/jdPay';
    import mainAPI from '@/api/main';
    import constantAPI from '@/api/constant';
    import wxShare from '@/utils/wxShareService';
    import pvuvAPI from '@/api/pvuv';

    export default {
        data() {
            return {
                query: {
                    traderId: this.$route.query.traderId,
                },
                jobInfo: {},
                phone: '',
                sum: 0,
                goodsName: '',
                confirmDialog: false,
                recordDialog: false,
                ruleDialog: false,
                shareDialogVisible: false,
                shareImgSrc: '',
                painting: {
                    width: '640px',
                    height: '1008px',
                    background: '#f4f5f7',
                    views: [
                        {
                            type: 'image',
                            url: require('../../../assets/posters/baitiao_phoneRecharge.png'),
                            css: {
                                // top: '20px',
                                // left: '36px',
                                // width: '80px',
                                // height: '80px'
                            }
                        },
                        {
                            type: 'rect',
                            css: {
                                top: '630px',
                                left: '430px',
                                color: '#fff',
                                width: '166px',
                                height: '166px'
                            }
                        },
                        {
                            type: 'qrcode',
                            content: window.location.href,
                            css: {
                                top: '633px',
                                left: '433px',
                                color: '#000',
                                width: '160px',
                                height: '160px'
                            }
                        }
                    ]
                }
            }
        },
        methods: {
            showConfirm(sum, goodsName) {
                if (!this.phone) {
                    this.$toast("请先输入手机号");
                    return;
                }
                if (!this.$myUtil.mobile(this.phone)) {
                    this.$toast("手机号不正确");
                    return;
                }
                this.sum = sum;
                this.goodsName = goodsName;
                this.confirmDialog = true;
            },
            confirmRecharge() {
                jdPayAPI.phoneRechargeJdPay(this.phone, this.goodsName, this.sum * 100).then((result) => {
                    window.location.href = result.data;
                }).catch(() => {
                });
            },
            confirmRecord() {
                window.location.href = this.jobInfo.linkAtrr1;
            },
            success(src) {
                this.shareImgSrc = src;
            },
            fail(err) {
                console.log('fail', err)
            },
        },
        created() {
            document.title = "话费充值立减10元";

            mainAPI.getInfoByTraderId(52, this.query.traderId).then((result) => {
                this.jobInfo = result.data;
                console.log(this.jobInfo.jobLink);
            }).catch(() => {
            })
        },
        mounted() {
            let shareInfo = {
                "imgUrl": "http://jho2o.oss-cn-beijing.aliyuncs.com/test/2O05KE2O.png",
                "title": "话费充值立减10元",
                "desc": "开通白条立减10元",
                "link": window.location.href,
            };
            constantAPI.weChatShareConfig(shareInfo.link).then((result) => {
                wxShare.setWxConfig(result.data);
                wxShare.setShare(shareInfo);
            });
            pvuvAPI.addPv("phoneRechargeJdPay/index", this.query.traderId).then((result) => {
            });
        }
    }

</script>

<style lang="scss" scoped>
    .background {
        background-image: url('http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NtrHgeh.png');
        background-size: 100% 100%;
        height: 63rem;
        padding-top: 18rem;
        text-align: center;
    }

    .inputForm {
        background-color: white;
        width: 90%;
        height: 30rem;
        margin: 0 auto;
        padding: 1rem 0;
        text-align: left;
    }

    .priceButton {
        width: 8rem;
        height: 6rem;
    }

</style>
